import { render, staticRenderFns } from "./TrashBinList.vue?vue&type=template&id=4d0907a2&scoped=true"
import script from "./TrashBinList.vue?vue&type=script&lang=js"
export * from "./TrashBinList.vue?vue&type=script&lang=js"
import style0 from "./TrashBinList.vue?vue&type=style&index=0&id=4d0907a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0907a2",
  null
  
)

export default component.exports